import type { Dish } from "../api/types";
import { resolveMediaUrl } from "../api/display";

export function LoadingScreen() {
  return (
    <main className="loading-screen">
      <div className="loading-heart">♥</div>
      <p>正在打开专属菜单</p>
    </main>
  );
}

export function DishPhoto({ dish, className = "" }: { dish: Dish; className?: string }) {
  const src = resolveMediaUrl(dish.image?.url);
  return src
    ? <img className={className} src={src} alt={dish.name} />
    : <div className={`image-placeholder ${className}`} aria-label={`${dish.name}暂无图片`}>🍽️</div>;
}

export function Toast({ message }: { message: string }) {
  return message ? <div className="toast" role="status">{message}</div> : null;
}

export function EmptyState({ icon, title, hint }: { icon: string; title: string; hint?: string }) {
  return (
    <div className="empty-state">
      <div>{icon}</div>
      <h2>{title}</h2>
      {hint && <p>{hint}</p>}
    </div>
  );
}
